import {
  createRouter,
  createWebHistory,
  type NavigationGuardNext,
  type RouteLocationNormalized,
} from 'vue-router'
import { useAppModeStore } from '@/stores/appMode'
import { useSessionStore } from '@/stores/session'
import { useCorpSessionStore } from '@/stores/corpSession'
import { authCookies, corpCookies } from '@/utils/cookies'
import { getRedirectUrl } from '@/utils/redirect'
import { redirectCorpAfterAuth, redirectPayAfterAuth } from '@/utils/postAuthRedirect'

function applyModeFromQuery(route: RouteLocationNormalized): void {
  const rawMode = route.query.mode
  const modeParam = Array.isArray(rawMode) ? rawMode[0] : rawMode
  const appModeStore = useAppModeStore()
  if (modeParam === 'corp' || modeParam === 'pay') {
    appModeStore.setMode(modeParam)
  }
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'auth',
      redirect: { name: 'login' },
      component: () => import('@/views/AuthLayout.vue'),
      children: [
        {
          path: 'login',
          name: 'login',
          component: () => import('@/views/LoginPage.vue'),
        },
        {
          path: '2fa',
          name: 'two-factor',
          component: () => import('@/views/TwoFactorPage.vue'),
        },
        {
          path: 'esqueci-senha',
          name: 'forgot-password',
          component: () => import('@/views/ForgotPasswordPage.vue'),
        },
        {
          path: 'redefinir-senha',
          name: 'reset-password',
          component: () => import('@/views/ResetPasswordPage.vue'),
          props: (route) => ({ 
            token: route.query.token,
            firstAccess: route.query.firstAccess,
          }),
        },
      ],
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: { name: 'login' },
    },
  ],
})

router.beforeEach((to, _from, next: NavigationGuardNext) => {
  applyModeFromQuery(to)
  getRedirectUrl()

  if (to.name === 'forgot-password' || to.name === 'reset-password') {
    next()
    return
  }

  if (to.name !== 'login') {
    next()
    return
  }

  const sessionStore = useSessionStore()
  const corpSessionStore = useCorpSessionStore()
  const appModeStore = useAppModeStore()

  sessionStore.syncFromCookies()
  corpSessionStore.syncFromCookies()

  if (appModeStore.isCorp && corpCookies.hasSession()) {
    redirectCorpAfterAuth(appModeStore.redirectUrl)
    next(false)
    return
  }

  if (appModeStore.isPay && authCookies.hasSession()) {
    const paySession = authCookies.getSession()
    if (paySession?.email && paySession?.token) {
      redirectPayAfterAuth(appModeStore.redirectUrl, paySession.email, paySession.token)
      next(false)
      return
    }
  }

  next()
})

export default router

